// extracted by mini-css-extract-plugin
export default {"root":"_20yW6","badge":"_1Enbh","rate":"_3p6f3","status":"_1n6T2","title":"_2rp5i","description":"wD-8E"};